import { makeGet, makePost, makePut, makeDelete } from './ServiceManager';

export const retrieveAllAdsInfo = async (adIds) => {
  const result = await makePost('service/ads', { ids: adIds });
  return result;
};

export const deleteUtms = async (data) => {
  const result = await makeDelete('service/utm', data);
  return result;
};

export const getUtms = async () => {
  const result = await makeGet('service/utm');
  return result;
};

export const updateUtm = async (data) => {
  const result = await makePost('service/utm', data);
  return result;
};

export const updateFieldUtm = async (data) => {
  const result = await makePost('service/utm', data);
  return result;
};

export const insertPresentationImport = (importData) => {
  const result = makePost('service/ad/import', importData);
  return result;
};

export const getPresentationImport = (url) => {
  const result = makeGet(`service/ad/import?url=${url}`);
  return result;
};

export const insertAdImport = (importData) => {
  const result = makePost('service/ad/import', importData);
  return result;
};

export const deleteAdImport = (id) => {
  const result = makeDelete('service/ad/import', id);
  return result;
};

export const getAdImports = (metadata) => {
  const _metadata = metadata === null ? '' : metadata;
  const result = makeGet(`service/ad/import${_metadata}`);
  return result;
};

export const insertAdNote = async (newNote) => {
  const result = await makePost('service/note', { note: newNote });
  return result;
};

export const updateNote = async (note) => {
  const result = await makePut('service/note', { note });
  return result;
};

export const approveQC = async (adQC) => {
  const result = await makePost('service/adqc', { adQC });
  return result;
};

export const getQc = async (id) => {
  const result = await makeGet(`service/adqc/${id}`);
  return result;
};

export const getNote = async (id) => {
  const result = await makeGet(`service/note/${id}`);
  return result;
};

export const clearAdQC = async (clearAd) => {
  const result = await makePut('service/adqc', { adQC: clearAd });
  return result;
};

export const updateAdHold = async (onhold) => {
  const result = await makePost('service/adqc/hold', { adQC: onhold });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/AdServiceManager.js